import React from "react";

interface SignalStrengthIconProps {
  level: number | null;
  fontSize?: number;
}

// gsm.signal.level from Flespi is a 0-100 percentage (confirmed against Flespi's Teltonika
// parameter reference), NOT a 0-4 bar index — a real reading of e.g. 45 or 68 is mid-strength,
// not "off the scale". Bucket it into the 4 bars a human actually reads at a glance.
function percentToBars(percent: number): number {
  if (percent <= 0) return 0;
  if (percent <= 25) return 1;
  if (percent <= 50) return 2;
  if (percent <= 75) return 3;
  return 4;
}

// 4 ascending bars, bottom-aligned — bars up to the current level are colored, the rest sit
// dim/grey so partial signal still reads as "signal", not "broken icon". null means no
// telemetry device or no recent v3 document.
const BAR_HEIGHTS = [5, 8, 11, 14];
const BAR_WIDTH = 3;
const BAR_GAP = 1.6;
const VIEWBOX_HEIGHT = 15;

export function SignalStrengthIcon({ level, fontSize = 16 }: SignalStrengthIconProps) {
  const activeBars = level == null ? 0 : percentToBars(level);
  const color = activeBars === 0 ? "#d1d5db" : activeBars === 1 ? "#ef4444" : activeBars === 2 ? "#f59e0b" : "#22c55e";
  const width = BAR_HEIGHTS.length * BAR_WIDTH + (BAR_HEIGHTS.length - 1) * BAR_GAP;

  return (
    <svg width={fontSize * (width / VIEWBOX_HEIGHT)} height={fontSize} viewBox={`0 0 ${width} ${VIEWBOX_HEIGHT}`}>
      <title>{level == null ? "No signal data" : `Signal ${level}%`}</title>
      {BAR_HEIGHTS.map((h, i) => (
        <rect
          key={i}
          x={i * (BAR_WIDTH + BAR_GAP)}
          y={VIEWBOX_HEIGHT - h}
          width={BAR_WIDTH}
          height={h}
          rx={0.9}
          fill={i < activeBars ? color : "#e5e7eb"}
        />
      ))}
    </svg>
  );
}
